import { EsAdditionalProduct } from "@edp-models/ES/es-product.model";

export interface IProductEsState {
    additionalProduct: EsAdditionalProduct;
}

export const initialProductState = {
    additionalProduct: null,
};

export const initialProductEsState: IProductEsState = {
    ...initialProductState,
};
